import React from 'react';
import {ButtonType, useObservable} from '@wix/devzai-utils-react';
import {
    DoppeActionTypeWidgetInnerButton
} from '../doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {OmitStrict} from '@wix/devzai-utils-common';
import IconLock from '../doppe-action-button-templates/doppe-standard-action-button-template/icons/Lock.svg';
import {useDoppeViewerClientServices} from '../../client/doppe-user-app/doppe-viewer-client-services';
import {IDoppeViewerActionContext} from '../../doppe-sdk';
import {doppeHideableValueIsVisibleAndNotEqualValue} from '../../client-server-common';

export const DoppeActionTypeWidgetInnerCtaButton = React.memo(function DoppeActionTypeWidgetInnerCtaButton(props: DoppeActionTypeWidgetInnerCtaButton.Props) {
    const {
        actionContext,
        onClick,
        isLoading,
        children,

        ...htmlAttributes
    } = props;

    const clientServices = useDoppeViewerClientServices();
    const isLockedObservable = clientServices.lockService.getActionLockObservable(actionContext.action);
    const isLocked = useObservable(isLockedObservable, observable => observable?.getValue() ?? false);

    const customButtonText = actionContext.action.lockSettings.lockPreviewInnerCtaButtonText;

    return (
        <DoppeActionTypeWidgetInnerButton
            {...htmlAttributes}
            buttonType={isLocked ? ButtonType.NormalButton : ButtonType.SubmitButton}
            suffixIcon={isLocked ? IconLock : undefined}
            isLoading={!isLocked && isLoading}
            onClick={isLocked ? () => {
                actionContext.startUnlocking(() => {
                    isLockedObservable?.setValue(false);
                }, false);
            } : onClick}
            children={isLocked && doppeHideableValueIsVisibleAndNotEqualValue(customButtonText, '') ? customButtonText : children}
        />
    );
});

export namespace DoppeActionTypeWidgetInnerCtaButton {

    export interface Props extends OmitStrict<DoppeActionTypeWidgetInnerButton.Props, 'suffixIcon'> {
        actionContext: IDoppeViewerActionContext;
    }

}
